module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.showCategoryPop = true;
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("商品类目 ")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.categoryName ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.categoryName || '请选择商品类目'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("商品轮播图（800*800）")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.formItem.imgList), function(item, $index) {
    return _c('div', {
      key: item.fileId,
      staticClass: "pic-box"
    }, [_c('img', {
      attrs: {
        "src": item.fileUrlView,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clean",
      on: {
        "click": function($event) {
          return _vm.delImg($index, 'imgList')
        }
      }
    })])
  }), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.imgList.length < 5),
      expression: "formItem.imgList.length < 5"
    }],
    attrs: {
      "multiple": true,
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterRead
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入商品名称"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.productName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productName", $$v)
      },
      expression: "formItem.productName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left"
  }, [_vm._v("副标题")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入副标题"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.subTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "subTitle", $$v)
      },
      expression: "formItem.subTitle"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center fs-32 color-333"
  }, [_c('div', {
    staticClass: "selection flex-center click",
    on: {
      "click": function($event) {
        _vm.isSkuMul = false
      }
    }
  }, [_c('div', [_vm._v("单规格")]), _vm._v(" "), _c('div', {
    staticClass: "alifont",
    class: [!_vm.isSkuMul ? 'icon-xuanzhong color-main' : 'icon-weixuanzhong color-666']
  })]), _vm._v(" "), _c('div', {
    staticClass: "selection flex-center",
    staticStyle: {
      "margin-left": ".8rem"
    },
    on: {
      "click": function($event) {
        _vm.isSkuMul = true
      }
    }
  }, [_c('div', [_vm._v("多规格")]), _vm._v(" "), _c('div', {
    staticClass: "alifont",
    class: [_vm.isSkuMul ? 'icon-xuanzhong color-main' : 'icon-weixuanzhong color-666']
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSkuMul),
      expression: "!isSkuMul"
    }],
    staticClass: "card pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("销售价")]), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-red"
  }, [_vm._v("￥")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "clearable": true,
      "placeholder": "请输入销售价"
    },
    on: {
      "click": _vm.inputClick
    },
    model: {
      value: (_vm.formItem.specialPrice),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "specialPrice", $$v)
      },
      expression: "formItem.specialPrice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left"
  }, [_vm._v("原价")]), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-red"
  }, [_vm._v("￥")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "clearable": true,
      "placeholder": "请输入原价"
    },
    on: {
      "click": _vm.inputClick
    },
    model: {
      value: (_vm.formItem.price),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "price", $$v)
      },
      expression: "formItem.price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("库存")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "digit",
      "clearable": true,
      "placeholder": "请输入商品库存"
    },
    on: {
      "click": _vm.inputClick
    },
    model: {
      value: (_vm.formItem.stockNum),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "stockNum", $$v)
      },
      expression: "formItem.stockNum"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSkuMul),
      expression: "isSkuMul"
    }]
  }, [_c('div', {
    staticClass: "spec-list"
  }, _vm._l((_vm.specList), function(spec, $index) {
    return _c('div', {
      key: $index,
      staticClass: "spec-item flex"
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(spec.specName))]), _vm._v(" "), _c('div', {
      staticClass: "flex1 flex",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, [_vm._l((spec.specValueList), function(value, $valueIndex) {
      return _c('div', {
        key: $valueIndex,
        staticClass: "spec-value-item"
      }, [_vm._v("\n                            " + _vm._s(value.specValueName) + "\n                            "), _c('img', {
        staticClass: "clean-img click",
        attrs: {
          "src": _vm.closeImgUrl,
          "alt": ""
        },
        on: {
          "click": function($event) {
            return _vm.delSpecValue(value.specValueName, $index, $valueIndex)
          }
        }
      })])
    }), _vm._v(" "), _c('div', {
      staticClass: "spec-value-add click",
      on: {
        "click": function($event) {
          return _vm.addSpecValue($index)
        }
      }
    }, [_vm._v("\n                            添加\n                        ")])], 2), _vm._v(" "), _c('div', {
      staticClass: "right alifont icon-shanchu color-red click",
      on: {
        "click": function($event) {
          return _vm.delSpec(spec.specName, $index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pd-250 text-center fs-32 color-main click",
    on: {
      "click": _vm.addSpec
    }
  }, [_vm._v("\n                添加自定义规格\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "sku-list"
  }, _vm._l((_vm.specGridCell), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "flex",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((item.specName), function(skuName, $skuNameIndex) {
      return _c('div', {
        key: $skuNameIndex,
        staticClass: "sku-spec-item"
      }, [_vm._v(" " + _vm._s(skuName.value))])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "pd-020"
    }, [_c('div', {
      staticClass: "input-field bd-bot"
    }, [_c('div', {
      staticClass: "fs-32 color-333 left required"
    }, [_vm._v("销售价")]), _vm._v(" "), _c('div', {
      staticClass: "fs-32 color-red"
    }, [_vm._v("￥")]), _vm._v(" "), _c('van-field', {
      staticClass: "input",
      attrs: {
        "type": "number",
        "clearable": true,
        "placeholder": "请输入销售价"
      },
      on: {
        "click": _vm.inputClick
      },
      model: {
        value: (item.specialPrice),
        callback: function($$v) {
          _vm.$set(item, "specialPrice", $$v)
        },
        expression: "item.specialPrice"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "input-field bd-bot"
    }, [_c('div', {
      staticClass: "fs-32 color-333 left"
    }, [_vm._v("原价")]), _vm._v(" "), _c('div', {
      staticClass: "fs-32 color-red"
    }, [_vm._v("￥")]), _vm._v(" "), _c('van-field', {
      staticClass: "input",
      attrs: {
        "type": "number",
        "clearable": true,
        "placeholder": "请输入原价"
      },
      on: {
        "click": _vm.inputClick
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "input-field"
    }, [_c('div', {
      staticClass: "fs-32 color-333 left required"
    }, [_vm._v("库存")]), _vm._v(" "), _c('van-field', {
      staticClass: "input",
      attrs: {
        "type": "digit",
        "clearable": true,
        "placeholder": "请输入商品库存"
      },
      on: {
        "click": _vm.inputClick
      },
      model: {
        value: (item.stockNum),
        callback: function($$v) {
          _vm.$set(item, "stockNum", $$v)
        },
        expression: "item.stockNum"
      }
    })], 1)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("商品介绍")]), _vm._v(" "), _c('div', {
    staticClass: "content-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.intro),
      expression: "formItem.intro"
    }],
    attrs: {
      "placeholder": "输入商品介绍信息，如：购买需知，商品/套餐情况内容等（非必填）"
    },
    domProps: {
      "value": (_vm.formItem.intro)
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "intro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("详情页")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式照片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.formItem.descpPicList), function(item, $index) {
    return _c('div', {
      key: item.fileId,
      staticClass: "pic-box"
    }, [_c('img', {
      attrs: {
        "src": item.descpPicView,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clean",
      on: {
        "click": function($event) {
          return _vm.delImg($index, 'descpPicList')
        }
      }
    })])
  }), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.descpPicList.length < 10),
      expression: "formItem.descpPicList.length < 10"
    }],
    attrs: {
      "multiple": true,
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterDescpPicRead
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCategoryPop),
      callback: function($$v) {
        _vm.showCategoryPop = $$v
      },
      expression: "showCategoryPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns,
      "value-key": "categoryName"
    },
    on: {
      "cancel": function($event) {
        _vm.showCategoryPop = false
      },
      "change": _vm.onChange,
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "添加自定义规格",
      "show-cancel-button": "",
      "before-close": _vm.sureAddSpec
    },
    model: {
      value: (_vm.addSpecShow),
      callback: function($$v) {
        _vm.addSpecShow = $$v
      },
      expression: "addSpecShow"
    }
  }, [_c('van-field', {
    staticClass: "dialog-input bd-bot",
    attrs: {
      "type": "text",
      "clearable": true,
      "maxlength": 4,
      "placeholder": "输入自定义规格，最多4个字"
    },
    model: {
      value: (_vm.newSpecName),
      callback: function($$v) {
        _vm.newSpecName = $$v
      },
      expression: "newSpecName"
    }
  })], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "添加规格值",
      "show-cancel-button": "",
      "before-close": _vm.sureAddSpecValue
    },
    model: {
      value: (_vm.addSpecValueShow),
      callback: function($$v) {
        _vm.addSpecValueShow = $$v
      },
      expression: "addSpecValueShow"
    }
  }, [_c('van-field', {
    staticClass: "dialog-input bd-bot",
    attrs: {
      "type": "text",
      "clearable": true,
      "maxlength": 10,
      "placeholder": "输入规格值，最多10个字"
    },
    model: {
      value: (_vm.newSpecValueName),
      callback: function($$v) {
        _vm.newSpecValueName = $$v
      },
      expression: "newSpecValueName"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4184c649","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/product/saveProduct.vue
// module id = Zgx4
// module chunks = 51